import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GoogleMap, Marker } from '@react-google-maps/api';
import axios from 'axios';
import { getRawPointsURL } from '../../../util/urlApi';
import Papa from 'papaparse';
import { USE_DARK_MODE } from '../../../util/constants';

const containerStyle = {
  width: '100%',
  height: '90%',
  border: `1px solid ${USE_DARK_MODE ? 'rgb(67, 67, 67)' : 'rgb(217, 217, 217)'}`,
  borderRadius: '2px'
};

const PPDMap = (props) => {
  const startDate = props.startDate;
  const endDate = props.endDate;
  const selectedDaysOfWeek = props.selectedDaysOfWeek;
  const todStart = props.todStart;
  const todEnd = props.todEnd;
  const journeyIdArray = useSelector(state => state.entities.pm.journeyIdArray);
  const [markers, set_markers] = useState(null);
  const sessionId = sessionStorage.getItem('sessionId');

  const center = props.center;

  useEffect(async () => {
    if (journeyIdArray.length > 0) {
      let points = [];
      let count = 0;

      let journeyIdArrayStr = encodeURIComponent(`${journeyIdArray.join(',')}`);
      const url = getRawPointsURL(startDate,
        endDate,
        selectedDaysOfWeek,
        todStart,
        todEnd,
        center.lat,
        center.lng);
      const result = await axios.get(url, {
        params: { journeyIdArrayStr },
        headers: { Authorization: `Bearer ${sessionId}` }
      });
      const geoHashPoints = Papa.parse(result.data,
        {
          header: true,
          skipEmptyLines: true
        }).data;
      for (let i in geoHashPoints) {
        const lat = geoHashPoints[i].geo.split(' ')[1];
        const lon = (geoHashPoints[i].geo.split(' ')[0]).split('POINT(')[1];
        points.push(
          <Marker
            key={count}
            icon={{
              url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
            }}
            position={{
              lat: parseFloat(lat),
              lng: parseFloat(lon)
            }}
          >
          </Marker>
        );
        count += 1;
      }
      set_markers(points);
    }
  }, [journeyIdArray, sessionId]);

  return (
    <GoogleMap
      options={{
        gestureHandling: 'greedy',
        mapId: USE_DARK_MODE ? 'bd86bab7d6f1db7e' : '3a93fb14d8979ea3',
      }}
      mapContainerStyle={containerStyle}
      center={center}
      zoom={15}
    >
      <Marker
        position={center}
      >
      </Marker>
      {markers}
    </GoogleMap>
  );
};
export default PPDMap;

